/**
 * profilePictures — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const profilePicturesPack: ToilePack = {
    slug: 'profile-pictures',
    category: 'pfp',
    name: 'Profile pictures',
    tagline: tagline('avatars', 'characters', 'styles'),
    chips: chips('characters', 'styles'),
    ratio: SQUARE,
    readings: [
        {key: 'bob', label: 'Silver bob', subject: 'a woman with a short silver bob, round sunglasses'},
        {key: 'beard', label: 'Bearded', subject: 'a man with a full dark beard, tortoiseshell glasses'},
        {key: 'hoodie', label: 'Hoodie', subject: 'a hooded figure, headphones around the neck'},
    ],
    styles: [
        {key: 'riso', label: 'Risograph', style: 'risograph print, two inks, visible grain', palette: 'fluorescent pink & teal', framing: 'head & shoulders, square crop'},
        {key: 'vector', label: 'Vector', style: 'flat vector illustration, bold clean shapes', palette: 'five-color flat fills', framing: 'head & shoulders, square crop'},
        {key: 'anime', label: 'Anime', style: 'anime cel-shaded, clean lineart', palette: 'pastel gradient background', framing: 'head & shoulders, square crop'},
    ],
    directions: ['with curly red hair', 'on a deep blue ground', 'smiling and warmer'],
}
